export default __webpack_public_path__ + "static/media/wave.491f6197.svg";